import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UploadCloud } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PageHero from "@/components/bakery/PageHero";
import { RegisterArt } from "@/components/bakery/Art";
import ManualSale from "@/components/kasir/ManualSale";
import SalesHistory from "@/components/kasir/SalesHistory";
import TxnDetailDialog from "@/components/common/TxnDetailDialog";
import { OutlineBtn } from "@/components/common/ui";
import { useAuth } from "@/context/AuthContext";
import { useApi } from "@/lib/useApi";

export const tabCls = "rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-semibold data-[state=active]:border-brand data-[state=active]:bg-transparent data-[state=active]:shadow-none";

export default function Kasir() {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const canImport = isAdmin || (user?.permissions || []).includes("import");
  const { data: products, reload } = useApi("/products");
  const [detail, setDetail] = useState(null);
  const [rk, setRk] = useState(0);
  return (
    <div data-testid="kasir-page">
      <PageHero testid="kasir-hero" eyebrow="Transaksi · Penjualan" title="Kasir" Art={RegisterArt}
        desc="Penjualan manual WhatsApp & Offline, termasuk Sample Gratis dan Endorsement. Tanpa harga — semua berbasis qty."
        actions={canImport && <OutlineBtn onClick={() => navigate("/kasir/import")} data-testid="go-import-btn"><UploadCloud className="h-4 w-4" /> Import Marketplace</OutlineBtn>} />
      <Tabs defaultValue="manual">
        <TabsList className="mb-6 h-auto w-full justify-start gap-2 rounded-none border-b border-zinc-200 bg-transparent p-0">
          <TabsTrigger value="manual" className={tabCls} data-testid="tab-kasir-manual">Input Manual</TabsTrigger>
          <TabsTrigger value="history" className={tabCls} data-testid="tab-kasir-history">Riwayat Struk</TabsTrigger>
        </TabsList>
        <TabsContent value="manual"><ManualSale products={products} onSaved={() => { reload(); setRk((x) => x + 1); }} /></TabsContent>
        <TabsContent value="history"><SalesHistory onOpen={setDetail} reloadKey={rk} /></TabsContent>
      </Tabs>
      <TxnDetailDialog txnId={detail} onClose={() => setDetail(null)} onChanged={() => setRk((x) => x + 1)} />
    </div>
  );
}
